export const emitRestDataChanged = ({ familyId, resource, action, item, itemId, extra } = {}) => {
  try {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent("fp:restDataChanged", {
      detail: { familyId, resource, action, item, itemId, extra, ts: Date.now() },
    }));
  } catch {}
};
